import styled from 'styled-components/macro';
import {
  fontSize,
  fontWeight,
  lineHeight,
  radius,
  shadow,
  space,
} from '../../../theme/tokens';

export const SayHelloMsg = styled.li`
  margin: 0;
  margin-top: ${space[5]};
  background: ${({ theme }) => theme.appBackground};
  border-radius: ${radius.pill};
  box-shadow: ${shadow.sm};
  justify-self: start;
  align-self: center;
  max-width: 100%;
  font-weight: ${fontWeight.semibold};
  font-size: ${fontSize.lg};
  line-height: ${lineHeight.normal};
  color: ${({ theme }) => theme.headerColour};
  text-align: center;
  padding: ${space[3]} ${space[5]};
`;
